
    <!--
 * 横版-兑换奖励
 * @LastEditTime: Mon Jan 06 2025 17:26:50 GMT+0800 (China Standard Time)
 -->
 <template>
  <div id="u_c_699X21"  :class="[`normal`,`u_c_699X21`]" ><div id="u_c_EKYK26"  v-html="compData.title" :class="[`${ compData.title ? 'text' : '' }`,`normal`,`u_c_EKYK26`]" ></div><div id="u_c_VWXA17"  v-html="compData.subTitle" :class="[`normal`,`u_c_VWXA17`]" ></div><div id="u_c_ZIK217"  :class="[`normal`,`u_c_ZIK217`]" ><span id="u_c_W98X20"  :class="[`normal txt `,`u_c_W98X20`]" >{{`${ langData.myLotteryTime }:`}}</span><span id="u_c_G4O1243"  :class="[`normal txt `,`u_c_G4O1243`]" >{{`${ pageData.lotteryTime }`}}</span><a id="u_c_CIC422" href="javascript:;" :class="[`normal txt `,`u_c_CIC422`]" @click="u_c_CIC422_event_MAWI24($event)">{{`[${ langData.refresh }]`}}</a></div><div id="u_c_97GI24"  :class="[`normal`,`u_c_97GI24`]" ><div id="u_c_G7XP20"  v-show="compData.exchangeInfo.length > compData.count" :class="[`normal swiper-button-prev-btn btn-light rtl-trans`,`u_c_G7XP20`]" ></div><div id="u_c_BUC617"  v-show="compData.exchangeInfo.length > compData.count" :class="[`normal swiper-button-next-btn btn-light `,`u_c_BUC617`]" ></div><swiper id="u_c_QZNF17"  :navigation="({
    nextEl: '.swiper-button-next-btn',
    prevEl: '.swiper-button-prev-btn'
})" :modules="modules" :slides-per-view="1" :class="[`normal`,`u_c_QZNF17`]" ><template   v-for="(slideItem, slideIndex) in compData.exchangeInfo" :key="slideIndex" ><swiper-slide id="u_c_HAC518"  v-if="!(slideIndex % compData.count) && !pageData.isEdit || pageData.isEdit && +slideIndex == 0" :class="[`normal`,`u_c_HAC518`]" ><div id="u_c_QWQK19"  v-for="(exchangeItem, eIndex) in compData.exchangeInfo" :key="eIndex" :class="[`normal`,`u_c_QWQK19`]" ><div id="u_c_LJFK25"  :data-index="exchangeItem.use" v-if="eIndex >= +slideIndex && eIndex < +slideIndex + +compData.count" :class="[`normal `,`u_c_LJFK25`]" ><div id="u_c_51RC62"  :class="[`normal btn-light`,`u_c_51RC62`]" @click="u_c_51RC62_event_00RH18($event,eIndex)"><div id="u_c_VZ9X63"  :class="[`normal txt `,`u_c_VZ9X63`]" >{{`${ langData.exchangeUse }`}}<div id="u_c_LTU465"  :class="[`normal txt`,`u_c_LTU465`]" >{{`${ exchangeItem.use }`}}</div></div><div id="u_c_7T3N26"  :style="`background-image:url(${ exchangeItem.pic })`" :class="[`normal`,`u_c_7T3N26`]" ></div><div id="u_c_SJW828"  v-show="exchangeItem.state == 2 || exchangeItem.state == void 0 && eIndex == 0" :class="[`normal`,`u_c_SJW828`]" ></div></div></div></div></swiper-slide></template></swiper></div><a id="u_c_NS5318" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`normal  btn-light  page-common-btn`,`u_c_NS5318`]" @click="u_c_NS5318_event_8J5W26($event)"><div id="u_c_WSMK19"  :class="[`normal page-common-btn`,`u_c_WSMK19`]" >{{`${ langData.getBtn }`}}</div></a></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import { Swiper, SwiperSlide } from "swiper/vue";import { Navigation } from "swiper";import "swiper/css";import "swiper/css/navigation"

    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"exchangeInfo":[{"name":"兑换奖励1\n兑换奖励1-1","use":"5","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"兑换奖励2\n兑换奖励2-2","use":"10","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"兑换奖励3\n兑换奖励3-3","use":"15","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"20张券","use":"20","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"25张券","use":"25","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"30张券","use":"30","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"35张券","use":"35","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"40张券","use":"40","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"45张券","use":"45","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"50张券","use":"50","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"55张券","use":"55","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"60张券","use":"60","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"65张券","use":"65","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"70张券","use":"70","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"75张券","use":"75","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"80张券","use":"80","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"85张券","use":"85","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"90张券","use":"90","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"95张券","use":"95","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"100张券","use":"100","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"}],"subTitle":`活动期间，在【天使的选择】中累计消耗抽奖券进行抽奖，
达到一定次数后即可免费领取对应奖励（次数不会重置）`,"count":8,"title":`成神祝福赠礼`},"zh-CN":{"exchangeInfo":[{"name":"钻石*400","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384170527422.png"},{"name":"高级招募硬币*2","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384119285948.png"},{"name":"精密升星选择补给箱*5","use":"15","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154175771.png"},{"name":"传奇英雄塔罗牌*2","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154303388.png"},{"name":"5星英雄选择牌*2","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384149745289.png"},{"name":"精密升星选择补给箱*10","use":"40","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384121314118.png"},{"name":"5星英雄万能碎片*1","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384147713731.png"},{"name":"专项图纸补给箱*1","use":"100","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172162211158701520.png"}],"subTitle":`活动期间，累计消耗的抽奖券达到一定的数量，可以解锁领取对应的奖励；`,"count":8,"title":`二重好礼`},"zh-TW":{"exchangeInfo":[{"name":"鑽石*400","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384170527422.png"},{"name":"高級招募硬幣*2","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384119285948.png"},{"name":"精密升星選擇補給箱*5","use":"15","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154175771.png"},{"name":"傳奇英雄塔羅牌*2","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154303388.png"},{"name":"5星英雄選擇牌*2","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384149745289.png"},{"name":"精密升星選擇補給箱*10","use":"40","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384121314118.png"},{"name":"5星英雄萬能碎片*1","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384147713731.png"},{"name":"專項圖紙補給箱*1","use":"100","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172162211158701520.png"}],"subTitle":`活動期間，累計消耗的抽獎券達到一定的數量，可以解鎖領取對應的獎勵；`,"count":8,"title":`二重好禮`},"en-US":{"exchangeInfo":[{"name":"Diamond*400","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384170527422.png"},{"name":"Adv. Recruit Coin*2","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384119285948.png"},{"name":"Promote Choice Box II*5","use":"15","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154175771.png"},{"name":"Epic Hero Card*2","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154303388.png"},{"name":"5★ Hero Choice Card*2","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384149745289.png"},{"name":"Promote Choice Box II*10","use":"40","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384121314118.png"},{"name":"5★ Hero Perfect Frag*1","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384147713731.png"},{"name":"Designated Design Box*1","use":"100","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172162211158701520.png"}],"subTitle":`Corresponding rewards will be unlocked when the total number of Lucky Tickets you use reaches a certain amount.`,"count":8,"title":`Bonus Gift`},"ja-JP":{"exchangeInfo":[{"name":"ダイヤ*400","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384170527422.png"},{"name":"Ⓡ（リクルートコイン）*2","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384119285948.png"},{"name":"選択型プロモート補給（エリート）*5","use":"15","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154175771.png"},{"name":"伝説英雄タロット*2","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154303388.png"},{"name":"★5英雄チョイス*2","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384149745289.png"},{"name":"選択型プロモート補給（エリート）*10","use":"40","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384121314118.png"},{"name":"★5英雄の万能欠片*1","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384147713731.png"},{"name":"専用設計図補給*1","use":"100","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172162211158701520.png"}],"subTitle":`イベント期間中、抽選で合計消費した抽選券の枚数が一定値に達すると対応するボーナスを獲得できます。`,"count":8,"title":`豪華ボーナス`},"ko-KR":{"exchangeInfo":[{"name":"다이아*400","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384170527422.png"},{"name":"고급 모집 코인*2","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384119285948.png"},{"name":"정밀 승성 선택 보급 상자*5","use":"15","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154175771.png"},{"name":"전설 영웅 타로카드*2","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154303388.png"},{"name":"5성 영웅 선택카드*2","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384149745289.png"},{"name":"정밀 승성 선택 보급 상자*10","use":"40","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384121314118.png"},{"name":"5성 영웅 만능 조각*1","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384147713731.png"},{"name":"전용 설계도 보급 상자*1","use":"100","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172162211158701520.png"}],"subTitle":`이벤트 기간 동안 뽑기권 누적 소모량이 일정 개수에 도달하면, 상응하는 보상을 받을 수 있습니다.`,"count":8,"title":`더블 보너스`},"th-TH":{"exchangeInfo":[{"name":"เพชร*400","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384170527422.png"},{"name":"เหรียญเกณฑ์ III*2","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384119285948.png"},{"name":"หีบเลือกอัปดาวก่อสร้าง*5","use":"15","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154175771.png"},{"name":"ไพ่ทาโรต์ฮีโร่ในตำนาน*2","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154303388.png"},{"name":"การ์ดเลือกฮีโร่ 5★*2","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384149745289.png"},{"name":"หีบเลือกอัปดาวก่อสร้าง*10","use":"40","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384121314118.png"},{"name":"ชิปวิเศษฮีโร่ 5★*1","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384147713731.png"},{"name":"หีบภาพอาวุธเฉพาะ*1","use":"100","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172162211158701520.png"}],"subTitle":`ช่วงกิจกรรมใช้คูปองจับรางวัลถึงจำนวนที่กำหนด ก็สามารถรับรางวัลที่สอดคล้องได้`,"count":8,"title":`รางวัล 2 ชั้น`},"vi-VN":{"exchangeInfo":[{"name":"Kim Cương*400","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384170527422.png"},{"name":"Xu Chiêu Mộ-Cao*2","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384119285948.png"},{"name":"Rương Chọn Tăng Sao Tuyệt Mật*5","use":"15","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154175771.png"},{"name":"Bài Tarot Anh Hùng Truyền Kỳ*2","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154303388.png"},{"name":"Bài Chọn Anh Hùng 5 Sao*2","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384149745289.png"},{"name":"Rương Chọn Tăng Sao Tuyệt Mật*10","use":"40","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384121314118.png"},{"name":"Mảnh Anh hùng 5 Sao Vạn Năng*1","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384147713731.png"},{"name":"Rương Cung Ứng Bản Vẽ Chuyên Mục*1","use":"100","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172162211158701520.png"}],"subTitle":`Trong thời gian hoạt động, tích lũy tiêu hao số Vé Rút Thưởng chỉ định, là mở khóa phần thưởng tương ứng;`,"count":8,"title":`Quà Thêm`},"de-DE":{"exchangeInfo":[{"name":"Diamant*400","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384170527422.png"},{"name":"Fortg. Rekrutmünze*2","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384119285948.png"},{"name":"Befördern Auswahlkiste II*5","use":"15","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154175771.png"},{"name":"Epische Heldkarte*2","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154303388.png"},{"name":"5★ Held Auswahlkarte*2","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384149745289.png"},{"name":"Befördern Auswahlkiste II*10","use":"40","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384121314118.png"},{"name":"5★ Held-Perfektes Fragment*1","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384147713731.png"},{"name":"Bestimmte Design Kiste*1","use":"100","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172162211158701520.png"}],"subTitle":`Die entsprechenden Belohnungen werden entsperrt, wenn die Gesamtzahl der von dir verwendeten Glückstickets eine bestimmte Menge erreicht.`,"count":8,"title":`Bonus-Geschenk`},"fr-FR":{"exchangeInfo":[{"name":"Diamant*400","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384170527422.png"},{"name":"Pièce recrutement av.*2","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384119285948.png"},{"name":"Boîte choix promotion II*5","use":"15","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154175771.png"},{"name":"Carte héros épique*2","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154303388.png"},{"name":"Carte choix héros 5★*2","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384149745289.png"},{"name":"Boîte choix promotion II*10","use":"40","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384121314118.png"},{"name":"Fragment parfait de héros 5★*1","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384147713731.png"},{"name":"Boîte de Conception Désignée*1","use":"100","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172162211158701520.png"}],"subTitle":`Les récompenses correspondantes seront débloquées lorsque le nombre total de Tickets Chanceux Tickets que vous avez utilisés atteindra un certain montant.`,"count":8,"title":`Cadeau Bonus`},"es-ES":{"exchangeInfo":[{"name":"Diamante*400","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384170527422.png"},{"name":"Moneda de Reclutamiento Avanzada*2","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384119285948.png"},{"name":"Caja de Selección de Promoción II*5","use":"15","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154175771.png"},{"name":"Tarjeta de héroe épico*2","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154303388.png"},{"name":"Caja de Selección de Héroe 5★*2","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384149745289.png"},{"name":"Caja de Selección de Promoción II*10","use":"40","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384121314118.png"},{"name":"Frag. Perfecto de Héroe 5★*1","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384147713731.png"},{"name":"Caja de diseño designada*1","use":"100","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172162211158701520.png"}],"subTitle":`Las recompensas correspondientes se desbloquearán cuando la cantidad total de tickets de la suerte que hayas utilizado alcance una cantidad determinada.`,"count":8,"title":`Regalo de bonificación`},"pt-PT":{"exchangeInfo":[{"name":"Diamante*400","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384170527422.png"},{"name":"Adv. Moeda de Recrutar*2","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384119285948.png"},{"name":"Caixa de Escolha de Promoção II*5","use":"15","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154175771.png"},{"name":"Cartão épico do herói*2","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154303388.png"},{"name":"5★ Carta de Escolha de Herói*2","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384149745289.png"},{"name":"Caixa de Escolha de Promoção II*10","use":"40","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384121314118.png"},{"name":"Fragmento de Herói Perfeito 5★*1","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384147713731.png"},{"name":"Caixa de design designada*1","use":"100","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172162211158701520.png"}],"subTitle":`As recompensas correspondentes serão desbloqueadas quando o número total de Bilhetes da Sorte que você usou atingir um determinado valor.`,"count":8,"title":`Presente Bônus`},"it-IT":{"exchangeInfo":[{"name":"Diamante*400","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384170527422.png"},{"name":"Gettone Recluta Avanzata*2","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384119285948.png"},{"name":"Scatola Scelta Promozione II*5","use":"15","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154175771.png"},{"name":"Carta Epica Eroe*2","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154303388.png"},{"name":"5★ Carta Scelta Eroe*2","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384149745289.png"},{"name":"Scatola Scelta Promozione II*10","use":"40","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384121314118.png"},{"name":"Framm. Eroe Perfetto 5★*1","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384147713731.png"},{"name":"Scatola Design Designata*1","use":"100","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172162211158701520.png"}],"subTitle":`Le ricompense corrispondenti verranno sbloccate quando il numero totale di biglietti fortunati che hai utilizzato raggiunge un determinato importo.`,"count":8,"title":`Regalo Bonus`},"tr-TR":{"exchangeInfo":[{"name":"Elmas*400","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384170527422.png"},{"name":"Gel. İşe Alım Parası*2","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384119285948.png"},{"name":"İlerletme Seçim Kutusu II*5","use":"15","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154175771.png"},{"name":"Epik Kahraman Kartı*2","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154303388.png"},{"name":"5★ Kahraman Seçim Kartı*2","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384149745289.png"},{"name":"İlerletme Seçim Kutusu II*10","use":"40","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384121314118.png"},{"name":"5★ Kahraman Mükemmel Parça*1","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384147713731.png"},{"name":"Belirlenmiş Tasarım Kutusu*1","use":"100","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172162211158701520.png"}],"subTitle":`İlgili ödüllerin kilidi, kullandığın toplam Şans Bileti sayısı belirli bir miktara ulaştığında açılacak.`,"count":8,"title":`Bonus Hediye`},"pl-PL":{"exchangeInfo":[{"name":"Diament*400","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384170527422.png"},{"name":"Moneta Rekruta Zaawansowanego*2","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384119285948.png"},{"name":"Pudełko z Wyborem Promocji II*5","use":"15","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154175771.png"},{"name":"Karta Epickiego Herosa*2","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154303388.png"},{"name":"Karta Wyboru 5★ Herosa*2","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384149745289.png"},{"name":"Pudełko z Wyborem Promocji II*10","use":"40","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384121314118.png"},{"name":"Idealny Frag. 5★ Herosa*1","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384147713731.png"},{"name":"Wyznaczone pudło projektowe*1","use":"100","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172162211158701520.png"}],"subTitle":`Odpowiednie nagrody zostaną odblokowane, gdy łączna liczba wykorzystanych przez Ciebie szczęśliwych biletów osiągnie określoną wartość.`,"count":8,"title":`Prezent bonusu`},"id-ID":{"exchangeInfo":[{"name":"Diamond*400","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384170527422.png"},{"name":"Adv. Rekrut Coin*2","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384119285948.png"},{"name":"Star up Choice Supply Box II*5","use":"15","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154175771.png"},{"name":"Legend Hero Tarot Card*2","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154303388.png"},{"name":"5★ Hero Choice Card*2","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384149745289.png"},{"name":"Star up Choice Supply Box II*10","use":"40","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384121314118.png"},{"name":"Fragmen Hero Universal 5★*1","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384147713731.png"},{"name":"Special Blueprint Supply Box*1","use":"100","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172162211158701520.png"}],"subTitle":`Overeenkomstige beloningen worden ontgrendeld als het totale aantal geluktstickets dat je hebt gebruikt een bepaald bedrag bereikt.`,"count":8,"title":`Bonus cadeau`},"ar-SA":{"exchangeInfo":[{"name":"الماس*400","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384170527422.png"},{"name":"عملات التجنيد المتقدم*2","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384119285948.png"},{"name":"صندوق ترقية النجوم II*5","use":"15","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154175771.png"},{"name":"بطاقة قطعة البطل*2","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384154303388.png"},{"name":"بطاقة اختيار البطل 5★*2","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384149745289.png"},{"name":"صندوق ترقية النجوم II*10","use":"40","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384121314118.png"},{"name":"قطعة بطل متعددة 5★*1","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716384147713731.png"},{"name":"صندوق تصميمات خاصة*1","use":"100","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172162211158701520.png"}],"subTitle":`Selama Event, akumulasi konsumsi Tiket Undi hingga jumlah tertentu bisa membuka hadiah relevan.`,"count":8,"title":`Bonus Hadiah`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '兑换奖励';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const initActivity = inject("initActivity", () => {})
const showTips = inject("showTips", (txt,code) => {})
const showGetSucc = inject("showGetSucc", (type, pic,name) => {})
const listData = inject("listData", {})
const canClickRefresh = inject("canClickRefresh", true)
const giftInfo = inject("giftInfo", {})

const curPlatform = pagePlatform;

const init = () => {
  compData.exchangeInfo.forEach((item) => {
    item.state = 0
  })
}

watch(
  () => listData,
  (value) => {
    if (value && value.exchangeList) {
      let confList = _.cloneDeep(compData.exchangeInfo)
      compData.exchangeInfo = []
      value.exchangeList.forEach((item, index) => {
        if( confList[index]){
          compData.exchangeInfo.push({
            pic: confList[index].pic,
            state: item.send_status,
            use: item.send_cost,
            id: item.id,
            name: confList[index].name,
          })}
      })
      giftInfo.exchangeAward = compData.exchangeInfo
    }
  },
  { deep: true }
)

init()

const canClickExchange = ref(true)
const exchangeFn = async (id, index) => {
  const link = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=exchangeAward`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=exchangeAward`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=exchangeAward`,
  }
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      id: id,
      language:curLang
    }),
  })
  if (res.result == 1) {
    compData.exchangeInfo[index].state = 2
    let curGiftName = res.data.send_type == 'sendSerial' ? res.data.send_value:compData.exchangeInfo[index].name;
    showGetSucc(res.data.send_type, compData.exchangeInfo[index].pic,curGiftName)
  } else {
    showTips(getLangTxt(res.code, getLangTxt("common")),res.code)
  }
  return res.result == 1
};
      // 更新按钮的click事件
      const u_c_CIC422_event_MAWI24= async (e)=>{
        try {if (!checkIsLogin()) return
        if (!checkIsBind()) return
        if(!canClickRefresh.value)return;
        canClickRefresh.value = false;
        initActivity();
        await utils.sleep(5);
        canClickRefresh.value = true;} catch (error) {console.log(error)}
      };
      // 自定义元素51RC62的click事件
      const u_c_51RC62_event_00RH18= async (e,index)=>{
        try {pageData.seeGift = [compData.exchangeInfo[index]]
pageData.seeGiftPopupState = true;} catch (error) {console.log(error)}
      };
      // 领取按钮的click事件
      const u_c_NS5318_event_8J5W26= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
if (!canClickExchange.value) return;
canClickExchange.value = false
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "领取兑换奖励",
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
let curIndex = compData.exchangeInfo.findIndex(item => item.state == 1);
if (~curIndex) {
  await exchangeFn(compData.exchangeInfo[curIndex].id, curIndex);
} else {
  let finishIndex = compData.exchangeInfo.findIndex(item => item.state == 2);
  showTips(
    getLangTxt(
      finishIndex == compData.exchangeInfo.length - 1 ? '-10011' : '-10013',
      getLangTxt('common')
    ),
    ''
  );
}
canClickExchange.value = true;} catch (error) {console.log(error)}
      };const modules = computed(()=> [Navigation])
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733822928652-73.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.default{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16715386566604.png);
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.default{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_W98X20.normal{
position:relative;

}
}.default{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.default{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.default{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.default{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649222586093.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.default{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649242679648.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.default{
.u_c_QZNF17.normal{
position:relative;

}
}.default{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.default{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.default{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.default{
.u_c_51RC62.normal{
position:relative;
width:10.94vw;
height:11.88vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
overflow:hidden;

}
}.default{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.04vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.default{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.default{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.default{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.21vw;

}
}.default{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.24vw;
font-weight:bold;

}
}.zh-CN{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733822928652-73.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.zh-CN{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.zh-CN{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-CN{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-CN{
.u_c_W98X20.normal{
position:relative;

}
}.zh-CN{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.zh-CN{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.zh-CN{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.zh-CN{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649222586093.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.zh-CN{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649242679648.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.zh-CN{
.u_c_QZNF17.normal{
position:relative;

}
}.zh-CN{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-CN{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.zh-CN{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.zh-CN{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.zh-CN{
.u_c_51RC62.normal{
position:relative;
width:10.94vw;
height:11.88vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
overflow:hidden;

}
}.zh-CN{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.04vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-CN{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.zh-CN{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.zh-CN{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.zh-CN{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.21vw;

}
}.zh-CN{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.24vw;
font-weight:bold;

}
}.zh-TW{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733822928652-73.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.zh-TW{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.zh-TW{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-TW{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-TW{
.u_c_W98X20.normal{
position:relative;

}
}.zh-TW{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.zh-TW{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.zh-TW{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.zh-TW{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649222586093.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.zh-TW{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649242679648.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.zh-TW{
.u_c_QZNF17.normal{
position:relative;

}
}.zh-TW{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-TW{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.zh-TW{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.zh-TW{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.zh-TW{
.u_c_51RC62.normal{
position:relative;
width:10.94vw;
height:11.88vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
overflow:hidden;

}
}.zh-TW{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.04vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-TW{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.zh-TW{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.zh-TW{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.zh-TW{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.21vw;

}
}.zh-TW{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.24vw;
font-weight:bold;

}
}.en-US{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733822928652-73.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.en-US{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.en-US{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.en-US{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.en-US{
.u_c_W98X20.normal{
position:relative;

}
}.en-US{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.en-US{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.en-US{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.en-US{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649222586093.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.en-US{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649242679648.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.en-US{
.u_c_QZNF17.normal{
position:relative;

}
}.en-US{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.en-US{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.en-US{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.en-US{
.u_c_51RC62.normal{
position:relative;
width:10.94vw;
height:11.88vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
overflow:hidden;

}
}.en-US{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.04vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.en-US{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.en-US{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.en-US{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.en-US{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.21vw;

}
}.en-US{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.24vw;
font-weight:bold;

}
}.ja-JP{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733887196983-36.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.ja-JP{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.ja-JP{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ja-JP{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.ja-JP{
.u_c_W98X20.normal{
position:relative;

}
}.ja-JP{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.ja-JP{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.ja-JP{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.ja-JP{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649222586093.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.ja-JP{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649242679648.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.ja-JP{
.u_c_QZNF17.normal{
position:relative;

}
}.ja-JP{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ja-JP{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.ja-JP{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.ja-JP{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.ja-JP{
.u_c_51RC62.normal{
position:relative;
width:10.94vw;
height:11.88vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
overflow:hidden;

}
}.ja-JP{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.04vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.ja-JP{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.ja-JP{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.ja-JP{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.ja-JP{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.21vw;

}
}.ja-JP{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.24vw;
font-weight:bold;

}
}.ko-KR{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733822928652-73.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.ko-KR{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.ko-KR{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ko-KR{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.ko-KR{
.u_c_W98X20.normal{
position:relative;

}
}.ko-KR{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.ko-KR{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.ko-KR{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.ko-KR{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649222586093.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.ko-KR{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649242679648.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.ko-KR{
.u_c_QZNF17.normal{
position:relative;

}
}.ko-KR{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ko-KR{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.ko-KR{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.ko-KR{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.ko-KR{
.u_c_51RC62.normal{
position:relative;
width:10.94vw;
height:11.88vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
overflow:hidden;

}
}.ko-KR{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.04vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.ko-KR{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.ko-KR{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.ko-KR{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.ko-KR{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.21vw;

}
}.ko-KR{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.24vw;
font-weight:bold;

}
}.th-TH{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733822928652-73.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.th-TH{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.th-TH{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.th-TH{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.th-TH{
.u_c_W98X20.normal{
position:relative;

}
}.th-TH{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.th-TH{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.th-TH{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.th-TH{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649222586093.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.th-TH{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649242679648.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.th-TH{
.u_c_QZNF17.normal{
position:relative;

}
}.th-TH{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.th-TH{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.th-TH{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.th-TH{
.u_c_51RC62.normal{
position:relative;
width:10.94vw;
height:11.88vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
overflow:hidden;

}
}.th-TH{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.04vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.th-TH{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.th-TH{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.th-TH{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.th-TH{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.21vw;

}
}.th-TH{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.24vw;
font-weight:bold;

}
}.vi-VN{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733822928652-73.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.vi-VN{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.vi-VN{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.vi-VN{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.vi-VN{
.u_c_W98X20.normal{
position:relative;

}
}.vi-VN{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.vi-VN{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.vi-VN{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.vi-VN{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649222586093.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.vi-VN{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649242679648.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.vi-VN{
.u_c_QZNF17.normal{
position:relative;

}
}.vi-VN{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.vi-VN{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.vi-VN{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.vi-VN{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.vi-VN{
.u_c_51RC62.normal{
position:relative;
width:10.94vw;
height:11.88vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
overflow:hidden;

}
}.vi-VN{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.04vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.vi-VN{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.vi-VN{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.vi-VN{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.vi-VN{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.21vw;

}
}.vi-VN{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.24vw;
font-weight:bold;

}
}.de-DE{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733822928652-73.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.de-DE{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.de-DE{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.de-DE{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.de-DE{
.u_c_W98X20.normal{
position:relative;

}
}.de-DE{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.de-DE{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.de-DE{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.de-DE{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649222586093.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.de-DE{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649242679648.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.de-DE{
.u_c_QZNF17.normal{
position:relative;

}
}.de-DE{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.de-DE{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.de-DE{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.de-DE{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.de-DE{
.u_c_51RC62.normal{
position:relative;
width:10.94vw;
height:11.88vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
overflow:hidden;

}
}.de-DE{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.04vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.de-DE{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.de-DE{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.de-DE{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.de-DE{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.21vw;

}
}.de-DE{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.24vw;
font-weight:bold;

}
}.fr-FR{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733822928652-73.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.fr-FR{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.fr-FR{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.fr-FR{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.fr-FR{
.u_c_W98X20.normal{
position:relative;

}
}.fr-FR{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.fr-FR{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.fr-FR{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.fr-FR{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649222586093.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.fr-FR{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649242679648.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.fr-FR{
.u_c_QZNF17.normal{
position:relative;

}
}.fr-FR{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.fr-FR{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.fr-FR{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.fr-FR{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.fr-FR{
.u_c_51RC62.normal{
position:relative;
width:10.94vw;
height:11.88vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
overflow:hidden;

}
}.fr-FR{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.04vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.fr-FR{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.fr-FR{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.fr-FR{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.fr-FR{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.21vw;

}
}.fr-FR{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.24vw;
font-weight:bold;

}
}.es-ES{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733822928652-73.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.es-ES{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.es-ES{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.es-ES{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.es-ES{
.u_c_W98X20.normal{
position:relative;

}
}.es-ES{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.es-ES{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.es-ES{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.es-ES{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649222586093.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.es-ES{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649242679648.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.es-ES{
.u_c_QZNF17.normal{
position:relative;

}
}.es-ES{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.es-ES{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.es-ES{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.es-ES{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.es-ES{
.u_c_51RC62.normal{
position:relative;
width:10.94vw;
height:11.88vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
overflow:hidden;

}
}.es-ES{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.04vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.es-ES{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.es-ES{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.es-ES{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.es-ES{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.21vw;

}
}.es-ES{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.24vw;
font-weight:bold;

}
}.pt-PT{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733822928652-73.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.pt-PT{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.pt-PT{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.pt-PT{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.pt-PT{
.u_c_W98X20.normal{
position:relative;

}
}.pt-PT{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.pt-PT{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.pt-PT{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.pt-PT{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649222586093.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.pt-PT{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649242679648.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.pt-PT{
.u_c_QZNF17.normal{
position:relative;

}
}.pt-PT{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.pt-PT{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.pt-PT{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.pt-PT{
.u_c_51RC62.normal{
position:relative;
width:10.94vw;
height:11.88vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
overflow:hidden;

}
}.pt-PT{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.04vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.pt-PT{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.pt-PT{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.pt-PT{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.pt-PT{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.21vw;

}
}.pt-PT{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.24vw;
font-weight:bold;

}
}.it-IT{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733822928652-73.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.it-IT{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.it-IT{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.it-IT{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.it-IT{
.u_c_W98X20.normal{
position:relative;

}
}.it-IT{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.it-IT{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.it-IT{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.it-IT{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649222586093.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.it-IT{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649242679648.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.it-IT{
.u_c_QZNF17.normal{
position:relative;

}
}.it-IT{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.it-IT{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.it-IT{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.it-IT{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.it-IT{
.u_c_51RC62.normal{
position:relative;
width:10.94vw;
height:11.88vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
overflow:hidden;

}
}.it-IT{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.04vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.it-IT{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.it-IT{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.it-IT{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.it-IT{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.21vw;

}
}.it-IT{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.24vw;
font-weight:bold;

}
}.tr-TR{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733822928652-73.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.tr-TR{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.tr-TR{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.tr-TR{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.tr-TR{
.u_c_W98X20.normal{
position:relative;

}
}.tr-TR{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.tr-TR{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.tr-TR{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.tr-TR{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649222586093.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.tr-TR{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649242679648.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.tr-TR{
.u_c_QZNF17.normal{
position:relative;

}
}.tr-TR{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.tr-TR{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.tr-TR{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.tr-TR{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.tr-TR{
.u_c_51RC62.normal{
position:relative;
width:10.94vw;
height:11.88vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
overflow:hidden;

}
}.tr-TR{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.04vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.tr-TR{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.tr-TR{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.tr-TR{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.tr-TR{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.21vw;

}
}.tr-TR{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.24vw;
font-weight:bold;

}
}.pl-PL{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733822928652-73.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.pl-PL{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.pl-PL{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.pl-PL{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.pl-PL{
.u_c_W98X20.normal{
position:relative;

}
}.pl-PL{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.pl-PL{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.pl-PL{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.pl-PL{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649222586093.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.pl-PL{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649242679648.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.pl-PL{
.u_c_QZNF17.normal{
position:relative;

}
}.pl-PL{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pl-PL{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.pl-PL{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.pl-PL{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.pl-PL{
.u_c_51RC62.normal{
position:relative;
width:10.94vw;
height:11.88vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
overflow:hidden;

}
}.pl-PL{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.04vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.pl-PL{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.pl-PL{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.pl-PL{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.pl-PL{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.21vw;

}
}.pl-PL{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.24vw;
font-weight:bold;

}
}.id-ID{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733822928652-73.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.id-ID{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.id-ID{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.id-ID{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.id-ID{
.u_c_W98X20.normal{
position:relative;

}
}.id-ID{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.id-ID{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.id-ID{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.id-ID{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649222586093.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.id-ID{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649242679648.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.id-ID{
.u_c_QZNF17.normal{
position:relative;

}
}.id-ID{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.id-ID{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.id-ID{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.id-ID{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.id-ID{
.u_c_51RC62.normal{
position:relative;
width:10.94vw;
height:11.88vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
overflow:hidden;

}
}.id-ID{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.04vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.id-ID{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.id-ID{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.id-ID{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.id-ID{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.21vw;

}
}.id-ID{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.24vw;
font-weight:bold;

}
}.ar-SA{
.u_c_699X21.normal{
position:relative;
width:100.00vw;
height:55.00vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733822928652-73.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_699X21.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.ar-SA{
.u_c_EKYK26.normal{
position:relative;
width:63.28vw;
height:6.25vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.08vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EKYK26.normal.text{
width:100%;
height:auto;

}
}.ar-SA{
.u_c_VWXA17.normal{
position:relative;
margin-top:1.09vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ar-SA{
.u_c_ZIK217.normal{
position:relative;
text-align:center;
margin-top:0.94vw;
display:flex;
justify-content:center;
align-items:center;

}
}.ar-SA{
.u_c_W98X20.normal{
position:relative;

}
}.ar-SA{
.u_c_G4O1243.normal{
position:relative;
margin:auto 0.52vw;

}
}.ar-SA{
.u_c_CIC422.normal{
position:relative;
margin-left:10.42vw;

}
}.ar-SA{
.u_c_97GI24.normal{
position:relative;
width:64.69vw;
margin:auto;
margin-top:0.83vw;
text-align:center;

}
}.ar-SA{
.u_c_G7XP20.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649222586093.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
left:0;

}
}.ar-SA{
.u_c_BUC617.normal{
position:absolute;
width:2.97vw;
height:4.58vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649242679648.png);
background-size:contain;
top:50%;
transform:translateY(-50%);
z-index:2;
/*!rtl:ignore*/;
right:0;

}
}.ar-SA{
.u_c_QZNF17.normal{
position:relative;

}
}.ar-SA{
.u_c_OD6618.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ar-SA{
.u_c_HAC518.normal{
position:relative;
width:100%;

}
}.ar-SA{
.u_c_QWQK19.normal{
position:relative;
display:inline-block;
font-size:1.04vw;

}
}.ar-SA{
.u_c_LJFK25.normal{
position:relative;
margin:auto 0.78vw 1.56vw;
display:inline-block;

}
}.ar-SA{
.u_c_51RC62.normal{
position:relative;
width:10.94vw;
height:11.88vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
overflow:hidden;

}
}.ar-SA{
.u_c_VZ9X63.normal{
position:relative;
margin-top:1.04vw;
font-size:1.15vw;
display:flex;
justify-content:center;
align-items:center;

}
}.ar-SA{
.u_c_LTU465.normal{
position:relative;
font-size:1.46vw;
font-weight:bold;
margin:auto 0.26vw;

}
}.ar-SA{
.u_c_7T3N26.normal{
position:relative;
width:9.90vw;
height:6.09vw;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:1.41vw;

}
}.ar-SA{
.u_c_SJW828.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.ar-SA{
.u_c_NS5318.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.21vw;

}
}.ar-SA{
.u_c_WSMK19.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.24vw;
font-weight:bold;

}
}
</style>
